import { DatabaseEntities } from "../../../common/models/database-entities.model";
import { EquipmentTypes } from "./enums/equipment-types.enum";

export class OtherEquipmentNames extends DatabaseEntities<OtherEquipmentNames> {
    value?: string;
    equipmentType?: EquipmentTypes;
}
